<template>
    <section class="info" :class="classes">
        <div class="text">
            <h2>{{ title }}</h2>
            <p v-html="description"/>
            <slot/>
        </div>
        <div class="image">
            <Video v-if="video" :src="video" :ratio="16 / 9"/>
            <!-- Wrapper needed to hide overflow with absolute child -->
            <div v-else class="wrapper">
                <Picture :src="picture" :ratio="16/9" :size="pictureSize"/>
                <div v-if="pictureAdditional" class="additional">
                    <Picture :src="pictureAdditional" :ratio="2/3" size="contain" color="white" zoomable/>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'BriefInfo',
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        video: {
            type: String,
            default: null,
        },
        picture: {
            type: String,
            default: null,
        },
        pictureAdditional: {
            type: String,
            default: null,
        },
        pictureCover: {
            type: Boolean,
            default: false,
        },
        reverse: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        classes () {
            return {
                reverse: this.reverse,
            };
        },
        pictureSize () {
            return this.pictureCover ? 'cover' : 'contain';
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

@mixin picture-wrapper () {
    box-shadow: 6px 6px 12px 0 rgba($black, .1);
    border-radius: 12px;
    overflow: hidden;
}

section {
    @include brief-section-grid();
    background-color: $white;

    &.reverse {
        > .image {
            grid-row: 1;
        }
    }

    > .text {
        > p + button {
            margin-top: 24px;
        }
    }

    > .image {
        position: relative;
        align-self: flex-start;

        > .wrapper {
            @include picture-wrapper();

            > .additional {
                @include picture-wrapper();
                position: absolute;
                left: -5%;
                bottom: -15%;
                width: 30%;
            }
        }
    }
}
</style>
